import React from 'react';
import PropTypes from 'prop-types';
import { pureRender } from 'epic-alt-utils/index';

@pureRender
class CallToAction extends React.Component {
    static propTypes = {
        callToAction: PropTypes.object
    };

    onClick = (e) => {
        const cta = this.props.callToAction || {};
        const onClick = cta.onClick;

        if (onClick && typeof onClick === 'function') {
            onClick(e);
        }
    };

    render() {
        const cta = this.props.callToAction || {};
        const href = cta.href || '';
        const title = cta.title || '';

        if (!title) {
            return <div />;
        }

        return (
            <div className="footer-cta-btn">
                <a
                    href={href}
                    className="accent-bg-color accent-bg-color-hover"
                    onClick={this.onClick}>
                    <span className="accent-text-color accent-text-color-hover">{title}</span>
                </a>
            </div>
        );
    }
}

export default CallToAction;



// WEBPACK FOOTER //
// ./app/scripts/components/button/CallToAction.js